import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.601 1.6a2.2 2.2 0 0 0-2.2 2.2v8.6a2 2 0 0 0 2 2h8.602c.332 0 .6-.267.6-.6s-.268-.6-.6-.6h-.2v-1.902a1.8 1.8 0 0 0 .8-1.498V3.4c0-.995-.805-1.8-1.8-1.8zm7.001 10v1.6H4.401a.8.8 0 1 1 0-1.6zm-7.201-1.2c-.285 0-.555.06-.8.168V3.8a1 1 0 0 1 1-1h7.202a.6.6 0 0 1 .6.6v6.4c0 .333-.268.6-.6.6zm1.2-5c0 .333.268.6.6.6h4.401c.333 0 .6-.267.6-.6s-.267-.6-.6-.6h-4.4c-.333 0-.6.268-.6.6m.6 1.8a.6.6 0 1 0 0 1.2h4.401c.333 0 .6-.267.6-.6s-.267-.6-.6-.6z" })
});
export default SvgBookRegularIcon;
